"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneSmsConfirmationInfo = PhoneSmsConfirmationInfo;
var React = _interopRequireWildcard(require("react"));
var _Link = require("../Link");
var _SubtitleLayout = require("../SubtitleLayout");
var styles = _interopRequireWildcard(require("./PhoneSmsConfirmationInfo.css"));
var _formatString = require("../../utils/formatString");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function PhoneSmsConfirmationInfo(_ref) {
  let {
    phone,
    onEditPhoneClick
  } = _ref;
  return /*#__PURE__*/React.createElement(_SubtitleLayout.SubtitleLayout, null, /*#__PURE__*/React.createElement("div", null, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0435\u0433\u043E\xA0\u043D\u0430\xA0", (0, _formatString.formatPhoneWithSpecialChars)(phone)), onEditPhoneClick && /*#__PURE__*/React.createElement("div", {
    className: styles['link']
  }, /*#__PURE__*/React.createElement(_Link.Link, {
    href: "#",
    onClick: onEditPhoneClick
  }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440")));
}